import React, { useEffect } from 'react'
import { useForm } from "react-hook-form";
import classes from './Form.module.css'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Gdpr from './gdpr/Gdpr';

const Form = (props) => {

    const { lang } = useParams();
    const { i18n } = useTranslation();
    useEffect(() => {
      i18n.changeLanguage(lang);
    }, [i18n, lang]);

    const { register, formState: { errors }, handleSubmit } = useForm({
        mode: 'onChange'
    });

    const onSubmit = (data) => {

        const body = {
            "firstname": data.name,
            "lastname": data.lastname,
            "email": data.email,
            "phone": data.phonenumber,
            "postcode": data.postcode,
            "city":  data.city,
            "country": data.country,
            "language": lang,
            "shop": "de"
        }
        props.onSubmitData(body);
    }
  return (
    <section className={classes.contact__form}>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <div className={classes.form__column}>
                <div className={classes.form__row}>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="text" 
                            placeholder={props.onTranslate('form__name')}
                            
                            {...register("name", { required: true })} 
                            aria-invalid={errors.name ? "true" : "false"} 
                        />
                        {errors.name?.type === 'required' && <p role="alert">{props.onTranslate('form__name_alert')}</p>}
                    </div>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="text"  
                            placeholder={props.onTranslate('form__lastname')} 
                            {...register("lastname", { required: true })} 
                            aria-invalid={errors.lastname ? "true" : "false"} 
                        />
                        {errors.lastname?.type === 'required' && <p role="alert">{props.onTranslate('form__lastname_alert')}</p>}
                    </div>
                </div>
                <div className={classes.form__row}>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="email" 
                            placeholder="email" 
                            {...register("email", { required: true })} 
                            aria-invalid={errors.email ? "true" : "false"} 
                        />
                        {errors.email?.type === 'required' && <p role="alert">{props.onTranslate('form__email_alert')}</p>}
                    </div>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="tel"
                            pattern="[0-9]*"
                            placeholder={props.onTranslate('form__phonenumber')}
                            {...register("phonenumber", { required: true })} 
                            aria-invalid={errors.phonenumber ? "true" : "false"} 
                        />
                        {errors.phonenumber?.type === 'required' && <p role="alert">{props.onTranslate('form__phonenumber_alert')}</p>}
                    </div>
                </div>
            </div>
            <div className={classes.form__column}>
                <div className={classes.form__row}>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="text" 
                            placeholder={props.onTranslate('form__postcode')}
                            {...register("postcode", { required: true })} 
                            aria-invalid={errors.postcode ? "true" : "false"} 
                        />
                        {errors.postcode?.type === 'required' && <p role="alert">{props.onTranslate('form__postcode_alert')}</p>}
                    </div>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="text" 
                            placeholder={props.onTranslate('form__city')} 
                            {...register("city", { required: true })} 
                            aria-invalid={errors.city ? "true" : "false"} 
                        />
                        {errors.city?.type === 'required' && <p role="alert">{props.onTranslate('form__city_alert')}</p>}
                    </div>
                </div>
                <div className={classes.form__row}>
                    <div className={classes.form__singleInput}>
                        <input 
                            type="text" 
                            placeholder={props.onTranslate('form__country')} 
                            {...register("country", { required: true })} 
                            aria-invalid={errors.country ? "true" : "false"} 
                        />
                        {errors.country?.type === 'required' && <p role="alert">{props.onTranslate('form__country_alert')}</p>}
                    </div>
                    <div className={classes.form__singleInput}>
                        <button
                            id="submit__button"
                            title={props.onTranslate('form__submit_title')}
                            className={classes.form__button}
                            type="submit">
                            {props.onTranslate('form__submit')}
                        </button>
                    </div>
                </div>
            </div>
            <div className={classes.form__consent}>
                <div className={classes.inputConsent}>
                    <label className={classes.checkboxLabel}>
                        <input
                            type="checkbox"
                            value="true"
                            className={classes.radio}
                            name="consent"
                            {...register("consent", { required: true })} 
                            aria-invalid={errors.consent ? "true" : "false"}
                        />
                        <span className={classes.checkmark}></span>
                        <div>
                        <p className={classes.consentText}>
                            <span>{props.onTranslate('form__consent1')}</span>
                            <span><a target="_blank" href="https://www.indigo-nails.com/en/privacy-policy-and-cookie-policy">{props.onTranslate('form__consent2')}</a></span>
                            <span>{props.onTranslate('form__consent3')}</span> 
                        </p>
                        </div>
                    </label>
                </div>
                {errors.consent?.type === 'required' && <p role="alert" className={classes.consent__alert}>{props.onTranslate('form__consent_alert')}</p>}
            </div>
        </form>
        <Gdpr
            onTranslate = {props.onTranslate}
        />
    </section>
  )
}

export default Form;